import HandleControl from './HandleControl.vue'

export default HandleControl
